/**
 * This component intentionally left blank.
 */
export function ServiceChargeForm() {
  return null;
}
